<div class="card">
  <div class="card-header d-flex align-items-center" *ngIf="cardHeader">
    <div class="col ps-0 py-1">
      {{ cardHeader | translate }}
    </div>
    <div class="col-auto pe-0">
      <ng-content select="pcs-card-header"></ng-content>
    </div>
  </div>

  <div *ngIf="!bodyHidden" class="card-body">
    <ng-content></ng-content>
  </div>
  <div class="card-footer" *ngIf="cardFooter">
    {{ cardFooter | translate }}
  </div>
</div>
